@if (label) {
<label
  >{{ label }}@if (requiredMark) {<span class="required-mark">&nbsp;*</span
  >}</label
>
}
<div class="input-container">
  @if (iconLeft) {
  <mat-icon class="left" [svgIcon]="iconLeft"> </mat-icon>
  }
  <input
    class="input"
    [placeholder]="placeholder"
    [type]="type"
    (blur)="onBlur()"
    [class.ng-invalid]="!ngControl?.valid"
    [class.ng-valid]="ngControl?.valid"
    [class.ng-touched]="ngControl?.touched"
    [class.ng-untouched]="!ngControl?.touched"
    [class.ng-pristine]="ngControl?.pristine"
    [class.ng-dirty]="!ngControl?.pristine"
    [class.icon-left]="iconLeft"
    [class.icon-right]="iconRight || fastDelete"
    (keydown)="onKeyDown($event)"
    [wmFrontAutofocus]="autofocus"
    [ngModel]="value"
    (ngModelChange)="setValue($event)"
    #input
    [disabled]="isDisabled"
    (focus)="focusEvent.emit()"
  />
  @if (iconRight) {
  <mat-icon
    class="right"
    (click)="clickOnIcon()"
    [svgIcon]="isCustom ? iconRight : ''"
  >
    {{ iconRight }}
  </mat-icon>
  }
  <mat-icon
    class="right reset"
    data-cy="reset"
    [hidden]="!!(fastDelete && !value) || !fastDelete"
    (click)="reset(); clickOnIcon()"
    svgIcon="close-sm"
    (click)="fastDeleted.emit()"
  >
  </mat-icon>
</div>
@if ( ngControl && !ngControl.valid && !ngControl.pristine && ngControl.touched
) {
<wm-front-form-error
  class="input-error"
  [error]="{
    keys: error?.keys ?? [],
    color: error?.color ?? '',
    position: error?.position ?? 'left',
    type: ngControl.errors
  }"
>
</wm-front-form-error>
}
